module.exports = __webpack_public_path__ + "static/media/wk-warranty.94e5f86c.svg";